export default __webpack_public_path__ + "static/media/book_open_blue.8ba29d64.png";